import * as React from 'react';
import { Uppy } from '@uppy/core';
import { Dashboard } from '@uppy/react';
import * as XHRUpload from '@uppy/xhr-upload';
import { fileToBase64 } from '../utils/helpers';
import { ImageObject } from '../utils/types';
require('@uppy/core/dist/style.css');
require('@uppy/dashboard/dist/style.css');

interface UploaderProps {
  onUpload?: (file: ImageObject) => void;
  onComplete?: (response: any) => void;
  initialImage?: ImageObject;
  allowedFileTypes?: string[];
}

export type UppyResponse = {
  response: {
    body: {
      scaled: string;
      thumbnail: string;
      original: string;
    };
  };
};

const Uploader: React.FC<UploaderProps> = ({ onUpload, onComplete, initialImage, allowedFileTypes = ['image/*'] }) => {
  const uppy = new Uppy({
    allowMultipleUploads: false,
    restrictions: {
      maxFileSize: 18000000,
      maxNumberOfFiles: 1,
      minNumberOfFiles: 1,
      allowedFileTypes,
    },
  });

  uppy.on('file-added', async (file) => {
    try {
      const base64 = await fileToBase64(file.data);
      uppy.setFileState(file.id, {
        data: base64.split(',').pop(),
      });

      uppy.use(XHRUpload, {
        endpoint: `https://c734jixdhg.execute-api.eu-west-1.amazonaws.com/prod/`,
        headers: { 'content-type': file.type },
        formData: false,
      });

      if (onUpload) {
        onUpload(file);
      }

      uppy.upload();
    } catch (error) {
      console.error('Error handling file:', error);
    }
  });

  uppy.on('complete', (result) => {
    if (result && result.successful && result.successful.length > 0) {
      if (onComplete) {
        onComplete(result.successful);
      }
    }
  });

  return <Dashboard uppy={uppy} height={400} />;
};

export default Uploader;



// WEBPACK FOOTER //
// ./src/components/Uploader.tsx